<template>
  <div id="container" style="width:100%;height: 440px;"></div>
</template>
<script>
import { Line } from '@antv/g2plot';

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    lineData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      line: {}
    };
  },
  watch: {
    items(n) {
      this.line.update(this.getOption());
    }
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      this.line = new Line('container', this.getOption());
      this.line.render();
    },
    getOption() {
      return {
        data: this.lineData,
        xField: 'count_by_date',
        yField: 'rate',
        seriesField: 'category',
        xAxis: {},
        yAxis: {
          label: {}
        },
        slider: {
          start: 0,
          end: 1
        }
      };
    }
  }
};
</script>
<style lang="less" scoped></style>
